(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("kSkug", function(module, exports) {
const $f328be1b00e2558f$var$init = ()=>{
    const INITIALIZED_CLASS = "--initialized";
    const faqs = document.querySelectorAll(`.i-faq:not(${INITIALIZED_CLASS})`);
    faqs.forEach((faq)=>{
        const header = faq.querySelector(".i-faq__header");
        header?.addEventListener("click", ()=>{
            faq.classList.toggle("--open");
        });
        faq.classList.add(INITIALIZED_CLASS);
    });
};
$f328be1b00e2558f$var$init();
document.addEventListener("faqsReinit", $f328be1b00e2558f$var$init);

});

})();
//# sourceMappingURL=faq-item.6c647b28.js.map
